import "./style/header_style.css";
import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiMenu, FiX } from 'react-icons/fi';
import { InitialRoute, LoginRoute, HomeRoute, CreateAccountRoute, DashboardRoute, OtpRoute } from "../../../../core/routes/route_constants.js";
import { useDispatch, useSelector } from "react-redux";
import { getUser, GetUserStatus } from "../../state/slice/user_slice.js";
import { userActions } from "../../state/store.js";
import usePixieDust from "../../../hooks/usePixieDust/usePixieDust.jsx";

const HeaderComp = () => {
    const erotixAILogo = "/logo/erotix_ai_logo.svg";
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    usePixieDust();

    const currentPath = location.pathname;
    const [menuOpen, setMenuOpen] = useState(false);

    const isHome = currentPath === InitialRoute || currentPath === HomeRoute;
    const isLogin = currentPath === LoginRoute || currentPath === CreateAccountRoute || currentPath === OtpRoute;

    const user = useSelector((state) => state.user.user);

    return (
        <div class="header-container flex flex-column justify-content-center align-items-center md:justify-content-between md:flex-row px-5 md:px-8 sm:px-5">
            <div class="flex flex-row justify-content-between align-items-center h-4rem w-full md:w-auto">
                <NavLink to={InitialRoute}>
                    <img class="header-logo h-4rem pixie-dust" src={erotixAILogo} alt="Erotix AI Logo" />
                </NavLink>
                <div className="menu-action-container text-white md:hidden" onClick={() => {
                    setMenuOpen(!menuOpen);
                }}>
                    {menuOpen ? <FiX size={30} /> : <FiMenu size={30} />}
                </div>
            </div>
            <div class={`${menuOpen ? 'flex' : 'hidden'} flex-column h-7rem align-items-center gap-3 md:h-auto md:flex md:flex md:flex-row md:gap-6`}>
                <Link class="menu-link menu-link-hover" to={HomeRoute}>
                    <div class="menu-item flex flex-column font-medium text-white text-lg md:text-xl">
                        Home
                        <div class={`${isHome ? "selected" : ""} menu-item-underline`}></div>
                    </div>
                </Link>
                <Link class="menu-link menu-link-hover" to={user != null ? DashboardRoute : LoginRoute}>
                    <div class="menu-item flex flex-column font-medium text-white text-lg md:text-xl">
                        {user != null ? user?.name ?? "Login" : "Login"}
                        <div class={`${isLogin ? "selected" : ""} menu-item-underline`}></div>
                    </div>
                </Link>
            </div>
        </div>
    );
    
}

export default HeaderComp;